import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Airport } from '@max/aircraft/models/airport.model';
import { AircraftLookupService } from '@max/aircraft/services/aircraft-lookup.service';
import { ILookup } from '@max/commercialpermitting/models/commercial-permit-lookup.interface';
import { BaseComponent } from '@max/shared/base-components/base.component';
import { AircraftModelModel } from '../../../models/aircraft-model.model';

export class AircraftAddManufacturerModalData {
    public makeId: number;

    constructor(
    ) {
    }
}

@Component({
    selector: 'add-aircraft-add-manufacturer-modal',
    templateUrl: './add-aircraft-add-manufacturer-modal.component.html'
})
export class AddAircraftAddManufacturerModalComponent extends BaseComponent {
    public dataLoaded = false;
    public manufacturerForm: FormGroup;
    public airports: Airport[];
    public aircraftMakes: ILookup[];
    public aircraftTypes: ILookup[];
    public aircraftMakeModels: ILookup[];
    public selectedAirport: Airport;
    public airportResults: string[];
    public makeResults: string[];
    public airportCounty: string;
    public airportCity: string;

    constructor(
        public dialogRef: MatDialogRef<AddAircraftAddManufacturerModalComponent>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: AircraftAddManufacturerModalData,
        private formBuilder: FormBuilder,
        private aircraftLookupService: AircraftLookupService
    ) {
        super();
        this.buildAircraftForm(this.data);
    }

    public ngOnInit(): void {

        this.aircraftLookupService.getAircraftLookups().subscribe((lookups) => {
            this.aircraftMakes = lookups.result.aircraftMakes;
            if (this.data.makeId) {
                let make = this.aircraftMakes.find(x => parseInt(x.value) == this.data.makeId);
                this.manufacturerForm.get('makeText').setValue(make.text);
            }
            this.dataLoaded = true;
        });
    }

    public cancel = (): void => {
        this.dialogRef.close();
    };

    public save = (): void => {
        let makeText = this.manufacturerForm.get('makeText').value;
        let modelText = this.manufacturerForm.get('modelText').value;

        var aircraftModel = new AircraftModelModel();
        if (this.data.makeId) {
            aircraftModel.aircraftMakeId = this.data.makeId;
        }
        aircraftModel.aircraftMakeDisplayValue = makeText;
        aircraftModel.aircraftModelDisplayValue = modelText;

        this.aircraftLookupService.addAircraftModel(aircraftModel).subscribe(r => {
            this.dialogRef.close(r.result);
        }, e => this.handleValidationResult(e));
    };

    private buildAircraftForm = (data?: AircraftAddManufacturerModalData): void => {
        this.manufacturerForm = this.formBuilder.group({
            makeText: [null, [Validators.required]],
            modelText: [null, [Validators.required]],
            selectedMakeId: [null],
            selectedMakeIdText: [null]
        });
    };

    public selectMake = (search: string): void => {
        let selectedMake = this.aircraftMakes.find(x => x.text.toLowerCase() === search.toLowerCase());
        if (selectedMake) {
            this.manufacturerForm.get('selectedMakeId').setValue(selectedMake.value);
            this.aircraftLookupService.getAircraftModelByMakeLookups(parseInt(selectedMake.value))
                .subscribe((models) => {
                    this.manufacturerForm.get('selectedMakeId').setValue(selectedMake.value);
                    this.manufacturerForm.get('selectedMakeIdText').setValue(selectedMake.text);
                });
        }
    };

    public searchMakes = (event: {query: string}): void => {
        let filteredMakes = this.aircraftMakes.filter(x => x.text.toLowerCase().includes(event.query.toLowerCase()));
        this.makeResults = filteredMakes.map(x => x.text);
    };
}
